// extracted by mini-css-extract-plugin
export default {"action":"GeneralPane_action__YNY7h","actionButton":"GeneralPane_actionButton__YsgK9","wrapper":"GeneralPane_wrapper__NKBN8"};